module.exports = __webpack_public_path__ + "img/textBox.d9221594.svg";